{
  "name": "@devvit/mcp",
  "version": "0.0.27",
  "description": "MCP for Devvit things",
  "bugs": "https://github.com/reddit/devvit-mcp/issues",
  "license": "BSD-3-Clause",
  "author": "Marcus Wood",
  "type": "module",
  "bin": {
    "devvit-mcp": "dist/index.js"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "node esbuild.js && shx chmod +x dist/*.js",
    "build:watch": "node esbuild.js --watch",
    "check": "npm run lint && npm run type-check && npm run prettier",
    "clean": "rm -rf ./dist ./fixtures ./db ./fixtures.tar.gz",
    "dev": "concurrently -p \"[{name}]\" -n \"ESBUILD,INSPECTOR\" -c \"blue,green\" \"npm run build:watch\" \"npm run dev:inspector\"",
    "dev:inspector": "npx --yes @modelcontextprotocol/inspector node ./dist/index.js",
    "lint": "eslint ./src",
    "lint:fix": "eslint --fix ./src",
    "prepare": "npm run check && npm run type-check && npm run build",
    "prettier": "sort-package-json ./package.json && prettier --write .",
    "scripts:generate-chunks": "NODE_NO_WARNINGS=1 tsx ./src/scripts/generateChunks.ts",
    "scripts:generate-sqlite-db": "NODE_NO_WARNINGS=1 tsx ./src/scripts/generateSqliteDb.ts",
    "scripts:hash-and-compare": "NODE_NO_WARNINGS=1 tsx ./src/scripts/hashAndCompare.ts",
    "test": "vitest",
    "type-check": "tsc --noEmit"
  },
  "dependencies": {
    "@langchain/core": "1.1.38",
    "@langchain/openai": "1.4.1",
    "@langchain/textsplitters": "1.0.1",
    "@modelcontextprotocol/sdk": "1.29.0",
    "@xenova/transformers": "2.17.2",
    "better-sqlite3": "11.9.1",
    "consola": "3.4.2",
    "jsdom": "26.0.0",
    "minimatch": "10.2.5",
    "remark": "15.0.1",
    "remark-gfm": "4.0.1",
    "remark-html": "16.0.1",
    "sqlite-vec": "0.1.7-alpha.2",
    "tar": "^7.5.11",
    "turndown": "7.2.0",
    "unified": "11.0.5",
    "zod": "3.25.20",
    "zod-to-json-schema": "3.24.6"
  },
  "devDependencies": {
    "@eslint/js": "9.39.4",
    "@types/better-sqlite3": "^7.6.13",
    "@types/jsdom": "~21.1.7",
    "@types/node": "22",
    "@types/semver": "7.7.0",
    "@types/turndown": "5.0.5",
    "concurrently": "9.1.2",
    "esbuild": "^0.25.4",
    "esbuild-plugin-copy": "2.1.1",
    "eslint": "9.39.4",
    "globals": "16.0.0",
    "p-queue": "8.1.0",
    "prettier": "3.5.3",
    "shx": "^0.4.0",
    "sort-package-json": "3.6.1",
    "tsx": "4.19.4",
    "typescript": "5.8.2",
    "typescript-eslint": "8.29.0",
    "vitest": "3.2.6"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "^4.43.0"
  },
  "_ci_version_source": "git-tags",
  "_comment": "This is a placeholder version that is updated by the CD pipeline"
}
